export const BIO_DATA = {
  dog: {
    // === HEPATOBİLİYER ===
    ALT:   { range: [0.2, 115], unit: "U/L" },      // Java: 0.2–115
    AST:   { range: [0.2, 120], unit: "U/L" },      // Java: 0.2–120
    ALP:   { range: [0.2, 150], unit: "U/L" },      // Java: 0.2–150
    GGT:   { range: [0.2, 16],  unit: "U/L" },      // Java: 0.2–16
    TBIL:  { range: [0, 17],    unit: "µmol/L" },   // Java: <17 normal
    CHOL:  { range: [0.3, 3.5], unit: "mmol/L" },   // Java: 0.3–3.5 (Total kolesterol)
    TG:    { range: [0.3, 2.13],unit: "mmol/L" },   // Java: 0.3–2.13 (Trigliserid)

    // === RENAL & METABOLİK ===
    BUN:   { range: [3.6, 8.9], unit: "mmol/L" },   // Java: 3.6–8.9
    CREA:  { range: [50, 250],  unit: "µmol/L" },   // Java: 50–250
    GLU:   { range: [70, 143],  unit: "mg/dL" },    // (orijinal)
    AMYL:  { range: [200, 1500],unit: "U/L" },      // (orijinal)
    LIPA:  { range: [200, 1800],unit: "U/L" },      // (orijinal)
    LDH:   { range: [34, 349],  unit: "U/L" },      // Java: 34–349

    // === PROTEİNLER ===
    TP:    { range: [60, 85],   unit: "g/L" },      // Java: 60–85
    ALB:   { range: [23, 31],   unit: "g/L" },      // Java: 23–31
    GLOB:  { range: [15, 45],   unit: "g/L" },      // Java: 15–45

    // === ELEKTROLİTLER ===
    CA:    { range: [1.95, 2.83], unit: "mmol/L" }, // Java: 1.95–2.83
    PHOS:  { range: [0.7, 2.23],  unit: "mmol/L" }, // Java: 0.7–2.23
    NA:    { range: [144, 160], unit: "mmol/L" },   // (orijinal)
    K:     { range: [3.5, 5.8],  unit: "mmol/L" },  // (orijinal)
    CL:    { range: [105, 122], unit: "mmol/L" },   // (orijinal)
  },
  cat: {
    // === HEPATOBİLİYER ===
    ALT:   { range: [0.1, 108], unit: "U/L" },      // Java: 0.1–108
    AST:   { range: [0.1, 113], unit: "U/L" },      // Java: 0.1–113
    ALP:   { range: [0.1, 145], unit: "U/L" },      // Java: 0.1–145
    GGT:   { range: [0.1, 14],  unit: "U/L" },      // Java: 0.1–14
    TBIL:  { range: [0.0, 14.0],unit: "µmol/L" },   // Java: 0.0–14.0
    CHOL:  { range: [0.3, 3.0], unit: "mmol/L" },   // Java: 0.3–3.0
    TG:    { range: [0.3, 2.13],unit: "mmol/L" },   // Java: 0.3–2.13

    // === RENAL & METABOLİK ===
    BUN:   { range: [3.6, 17],  unit: "mmol/L" },   // Java: 3.6–17
    CREA:  { range: [44, 230],  unit: "µmol/L" },   // Java: 44–230
    GLU:   { range: [71, 159],  unit: "mg/dL" },    // (orijinal)
    AMYL:  { range: [300, 1500],unit: "U/L" },      // (orijinal)
    LIPA:  { range: [0, 250],   unit: "U/L" },      // (orijinal)
    LDH:   { range: [34, 335],  unit: "U/L" },      // Java: 34–335

    // === PROTEİNLER ===
    TP:    { range: [54, 83],   unit: "g/L" },      // Java: 54–83
    ALB:   { range: [25, 52],   unit: "g/L" },      // Java: 25–52
    GLOB:  { range: [12, 39],   unit: "g/L" },      // Java: 12–39

    // === ELEKTROLİTLER ===
    CA:    { range: [1.95, 2.83], unit: "mmol/L" }, // Java: 1.95–2.83
    PHOS:  { range: [0.7, 2.23],  unit: "mmol/L" }, // Java: 0.7–2.23
    NA:    { range: [150, 165], unit: "mmol/L" },   // (orijinal)
    K:     { range: [3.5, 5.8],  unit: "mmol/L" },  // (orijinal)
    CL:    { range: [112, 129], unit: "mmol/L" },   // (orijinal)
  },
};

export const runFullBioAnalysis = (species, v) => {
    const findings = [];
    const data = BIO_DATA[species];
    const vals = Object.fromEntries(Object.entries(v).map(([k, val]) => [k, parseFloat(val)]));

    // --- KLİNİK ANALİZ MANTIĞI ---
    
    // Renal Kontrol
    if (vals.BUN > data.BUN.range[1] || vals.CREA > data.CREA.range[1]) {
        const ratio = vals.BUN / vals.CREA;
        let msg = ratio > 20 ? "Prerenal Azotemi Şüphesi (Dehidratasyon/GİS Kanama)" : "Renal Azotemi Şüphesi";
        findings.push({ title: "Böbrek", msg: `${msg}. USG ile korele edilmelidir.`, level: "danger" });
    }

    // Karaciğer Kontrol
    if (vals.ALT > data.ALT.range[1] * 3) {
        findings.push({ title: "Karaciğer", msg: "Şiddetli Hepatosellüler Hasar / Nekroz.", level: "danger" });
    }

    // A/G Oranı (Kedi)
    if (species === 'cat' && vals.ALB && vals.TP) {
        const globulin = vals.TP - vals.ALB;
        const agRatio = vals.ALB / globulin;
        if (agRatio < 0.6) {
            findings.push({ title: "A/G Oranı", msg: `Oran: ${agRatio.toFixed(2)}. FIP açısından yüksek klinik şüphe!`, level: "danger" });
        }
    }

    return findings;
};